import { render, staticRenderFns } from "./ConfigureTokens.vue?vue&type=template&id=4a9d0310&scoped=true&"
import script from "./ConfigureTokens.vue?vue&type=script&lang=js&"
export * from "./ConfigureTokens.vue?vue&type=script&lang=js&"
import style0 from "./ConfigureTokens.vue?vue&type=style&index=0&id=4a9d0310&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9d0310",
  null
  
)

export default component.exports